<template>
  <CardTable
    :loading="loadingAlerts"
    header="Past Alerts"
    :tableHeaders="headers"
    :tableData="pastAlerts.restAlertList"
  />
</template>

<script>
import CardTable from '@shared/components/service/component/CardTable.vue';
import { mapState } from 'vuex';
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'PastAlertsTable',
  components: { CardTable },
  mixins: [serviceMixin],
  data() {
    return {
      headers: [{
        text: 'Date',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'startTime',
      }, {
        text: 'Alert',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'title',
      }, {
        text: 'System Name',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'systemName',
      }, {
        text: 'Serial',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'serial',
      }, {
        text: 'Location',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'location',
      }, {
        text: 'First Occurred',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'firstOccurred',
      }, {
        text: 'Last Occurred',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'lastOccurred',
      }],
    };
  },
  computed: {
    ...mapState({
      loadingAlerts: (state) => state.service.loadingAlerts,
    }),
  },
};
</script>
